// extracted by mini-css-extract-plugin
export default {"floatBtn":"WhatsAppFloat_floatBtn__ATc8p","icon":"WhatsAppFloat_icon__qIjIm","pulse":"WhatsAppFloat_pulse__OIDzP"};